module.exports = __webpack_public_path__ + "static/media/img_logo_plus.33a48e71.png";